import constants from '$$helpers/constants';

const LABEL_COLORS = [
  { id: 1, hex: '#4DB6AC' },
  { id: 2, hex: '#7986CB' },
  { id: 3, hex: '#CE93D8' },
  { id: 4, hex: '#50C7D6' },
  { id: 5, hex: '#FFAB91' },
  { id: 6, hex: '#81C784' },
  { id: 7, hex: '#EB8686' },
  { id: 8, hex: '#78909C' },
  { id: 9, hex: '#C0CA33' },
  { id: 10, hex: '#F9D06B' },
  { id: 11, hex: '#A1887F' },
];

export const ColorCycler = (() => {
  let colorCounter = 0;
  const groupColorMap = {};

  return {
    getColor(key) {
      if (!groupColorMap[key]) {
        const colors = LABEL_COLORS;

        groupColorMap[key] = colors[colorCounter % colors.length].hex;
        colorCounter++;
      }

      return groupColorMap[key];
    },
  };
})();

export default {
  changeTableDataByGroups(newGrouping, tableData) {
    if (newGrouping.includes('assignee')) {
      const exploded = this.getExplodedTasks(tableData);

      return exploded;
    }

    return tableData;
  },

  getExplodedTasks(tasks) {
    return tasks.flatMap(task => {
      if (!task.assignee || task.assignee.length === 0) {
        return [{ ...task, assignee: { id: '-1', name: __('notAssigned') } }];
      }

      return task.assignee.map(a => ({
        ...task,
        assignee: { ...a },
      }));
    });
  },

  getColumnVisibilityByCalculationMode(tableConfig, calculationMode) {
    let disabledColumns = [];

    if (calculationMode === constants.OVERVIEW_TYPES.ACTUAL_TO_PLANNED) {
      disabledColumns = ['baseline_budget', 'cum_baseline_budget', 'baseline_estimation', 'cum_baseline_estimation', 'baseline_progress'];
    }

    if (calculationMode === constants.OVERVIEW_TYPES.ACTUAL_TO_BASELINE) {
      disabledColumns = ['budget', 'cum_budget', 'estimation', 'cum_estimation', 'progress'];
    }

    if (calculationMode === constants.OVERVIEW_TYPES.PLANNED_TO_BASELINE) {
      disabledColumns = ['actual_cost', 'cum_actual_cost', 'logs', 'cum_logs', 'actual_progress'];
    }

    const columns = tableConfig.columns;
    const columnVisibility = Object.fromEntries(
      columns.map(col => [col.accessorKey, !disabledColumns.includes(col.accessorKey)]),
    );

    return {
      ...tableConfig,
      state: {
        ...tableConfig.state,
        columnVisibility,
      },
    };
  },
};
